import presentationChat from './chat.module'
import presentationSettings from './presentation-settings.module'
import presentationAttributeModule from './presentation-attribute.module'
import themeModule from './theme.module'

export default {
  presentationChat,
  presentationSettings,
  presentationAttributeModule,
  themeModule,
}
